import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  Routes,
  Route,
  useLocation,
  useNavigate,
  useParams,
} from "react-router";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import ColorPaletteLayout from "./components/color-palette";
import HomeLayout from "./components/home";
import AboutLayout from "./components/about";
import "./sass/index.scss";

export function withRouter(Component) {
  function ComponentWithRouterProp(props) {
    const location = useLocation();
    const navigate = useNavigate();
    const params = useParams();

    return <Component {...props} router={{ location, navigate, params }} />;
  }

  return ComponentWithRouterProp;
}

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: undefined,
      checkingLogin: true,
    };
  }

  navigateProfile() {
    this.props.router.navigate("/profile");
  }

  render() {
    return (
      <div className="App">
        <Header />

        <Routes>
          <Route
            path="/color-palette/:paletteid?"
            element={<ColorPaletteLayout router={this.props.router} />}
          />
          {/* <Route path="/color-palette/:paletteid?" render={ routeProps => (
        <ColorPaletteLayout router={this.props.router} {...routeProps} />
      )}
      />
      <Route path="/profile">
        <ProfileLayout profile={this.state.user} checkingLogin={this.state.checkingLogin}/>
      </Route> */}
          <Route
            path="/"
            index
            element={<HomeLayout profile={this.state.user} />}
          />
          <Route
            path="/about"
            element={<AboutLayout profile={this.state.user} />}
          />
        </Routes>
        <Footer />
      </div>
    );
  }
}

App.propTypes = {
  router: PropTypes.shape({
    navigate: PropTypes.func,
  }),
};

export default withRouter(App);
